'use strict';

import { handleTransition } from 'Util/transitions.js';
import constants from 'Util/constants';
import { appendParamToURL } from 'Util/urlUtils';

class VZRoaming extends HTMLElement {
    constructor() {
        super();
        this.toggleCheckbox = null;
        this.fixedAmountInfo = null;
        this.nonFixedAmountInfo = null;
        this.boundHandleToggleChange = this.handleToggleChange.bind(this);
    }

    connectedCallback() {
        this.toggleCheckbox = this.querySelector('.js-roaming-outside-eu');
        this.fixedAmountInfo = this.querySelector('.js-fixed-amount-info');
        this.nonFixedAmountInfo = this.querySelector('.js-non-fixed-amount-info');

        if (this.toggleCheckbox) {
            this.toggleCheckbox.addEventListener(constants.events.change, this.boundHandleToggleChange);
        }
    }

    handleToggleChange(event) {
        const isChecked = event.target.checked;

        if (this.fixedAmountInfo && this.nonFixedAmountInfo) {
            handleTransition(() => {
                this.fixedAmountInfo.classList.toggle(constants.classes.dNone, !isChecked);
                this.nonFixedAmountInfo.classList.toggle(constants.classes.dNone, isChecked);
            });

            this.updateRoamingAddonUrls(isChecked);
            this.triggerVariationUpdate();
        }
    }

    updateRoamingAddonUrls(roamingEnabled) {
        const roamingAddons = this.querySelectorAll('.js-roaming-addon');
        roamingAddons.forEach((addon) => {
            const currentUrl = addon.dataset.url;
            if (currentUrl) {
                addon.dataset.url = appendParamToURL(currentUrl, 'roamingEnabled', roamingEnabled);
            }
        });
    }

    triggerVariationUpdate() {
        const roamingAddons = this.querySelectorAll('.js-roaming-addon');
        if (roamingAddons.length === 0) return;

        const addonToTrigger = Array.from(roamingAddons).find((addon) => addon.checked) || roamingAddons[0];

        if (addonToTrigger) {
            addonToTrigger.dispatchEvent(new Event('change'));
        }
    }

    disconnectedCallback() {
        if (this.toggleCheckbox) {
            this.toggleCheckbox.removeEventListener(constants.events.change, this.boundHandleToggleChange);
        }
    }
}

export default window.customElements.get('vz-roaming') || VZRoaming;
if (!window.customElements.get('vz-roaming')) {
    window.customElements.define('vz-roaming', VZRoaming);
}
